import { render, staticRenderFns } from "./KSSDCCAssign.vue?vue&type=template&id=e183bcd2&lang=pug&"
import script from "./KSSDCCAssign.vue?vue&type=script&lang=js&"
export * from "./KSSDCCAssign.vue?vue&type=script&lang=js&"
import style0 from "./KSSDCCAssign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports